import { CircularProgress, Grid } from "@mui/material";
import { Construction as BuildIcon } from "@mui/icons-material";
import styled from "styled-components";

export const LEARN_TO_USE_PDF_PAGE_WIDTH = 720;

export const SContainer = styled(Grid)`
  && {
    font-family: ${({ theme }) => theme.fonts.primary};
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
  }
`;

export const SIconWrapper = styled.div`
  background-color: #f8f0e5;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SBuildIcon = styled(BuildIcon)`
  color: #e38b29;
  font-size: 40px !important;
`;

export const SHeading = styled.h1`
  font-size: 1.75rem;
  font-weight: 500;
  color: #2d2d2d;
  margin: 0;
  position: relative;
  display: inline-block;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(
      90deg,
      rgba(227, 139, 41, 0) 0%,
      rgba(227, 139, 41, 0.3) 50%,
      rgba(227, 139, 41, 0) 100%
    );
  }
`;

export const SText = styled.p`
  padding: 30px;
  text-align: center;
  font-size: 1rem;
`;

export const SPdfContainer = styled.div`
  background-color: #fff;
  width: 100vw;
  height: 100vh;

  overflow-y: auto;
  display: flex;
  justify-content: center;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d6d3d3;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-button:start:increment {
    height: 0;
    display: block;
    background: transparent;
  }
`;

export const SPdfWrapper = styled.div`
  width: 100%;
  max-width: ${LEARN_TO_USE_PDF_PAGE_WIDTH}px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0;
`;

export const SPdfLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const SCircularProgress = styled(CircularProgress)`
  && {
    color: ${({ theme }) => theme.colors.addButtonSecondary};
  }
`;

export const SLink = styled.a`
  color: #333;
  text-decoration: underline;
  font-weight: 500;

  &:hover {
    color: #000;
  }
`;
